import React from 'react';
import {Box, Grid, TextField, Typography, Button, MenuItem, } from "@mui/material";
import swal from "sweetalert";
import {getFoodData, getFoodTotalProductionValue, getFoodAverageNetIncomePerFarm, getFoodOperatingExpenseRatio} from '../../utilityFunctions/DataloveUtil';
import Colors from "../../components/ui/Colors";
import CustomLoader from "../../components/CustomLoader";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from 'recharts';

// Add these constants for the pie chart colors
//const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d'];
const COLORS = [
  '#4A3596',
  '#27A2AA', 
  '#281845',
  '#F2736A',
  '#E0E0E0',
  '#1E385B',
  '#AFAFAF'
];

const YEARS = [2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024];

const foodDataRequest={};

export default function DataAnalytics(props) {

    const {loginUser} = props;

    const [loading, setLoading] = React.useState(false);

    const [foodData, setFoodData] = React.useState(null);
    const [productionData, setProductionData] = React.useState(null);
    const [incomeData, setIncomeData] = React.useState(null);
    const [expenseData, setExpenseData] = React.useState(null);

    const [year, setYear] = React.useState("");

    const { t } = useTranslation();

    let history = useHistory();

    React.useEffect(() => {
      const loadInitialValues = async () => {
        await initialValues();
      }
      // loadInitialValues();
    }, []);

    const initialValues = async () => {
      
        setLoading(true);
        const foodData = await getFoodData({year: 2020}, loginUser.jwtToken );
        setLoading(false);

        if(!foodData){
            swal("Error", "Failed to fetch food data", "error");
        };

        setFoodData(foodData);
        console.log(foodData);
    }

    const yearChange = async(e) => {
      setYear(e.target.value);
      foodDataRequest.year = e.target.value;

      setLoading(true);
      Promise.all([
        getFoodData(foodDataRequest, loginUser.jwtToken),
        getFoodTotalProductionValue(foodDataRequest, loginUser.jwtToken),
        getFoodAverageNetIncomePerFarm(foodDataRequest, loginUser.jwtToken), 
        getFoodOperatingExpenseRatio(foodDataRequest, loginUser.jwtToken)
      ]).then(([foodDataResponse, productionResponse, incomeResponse, expenseResponse]) => {
        console.log('Food Data:', foodDataResponse);
        console.log('Production Data:', productionResponse);
        console.log('Income Data:', incomeResponse);
        console.log('Expense Data:', expenseResponse);
        
        setLoading(false);
        if(foodDataResponse) {
          setFoodData(foodDataResponse);
        }
        if(productionResponse) {
          setProductionData(productionResponse);
        }
        if(incomeResponse) {
          setIncomeData(incomeResponse); 
        }
        if(expenseResponse) {
          setExpenseData(expenseResponse);
        }
      }).catch(error => {
        setLoading(false);
        console.error("Error fetching data:", error);
        swal("Error", "Failed to fetch data", "error");
      });

      // if(!foodData){
      //     swal("Error", "Failed to fetch food data", "error");
      // };

      // setFoodData(foodData);
    };

    // Add this function to prepare data for the pie chart

    const preparePieChartData = () => {
      if (!foodData || !foodData.data) return [];
      return foodData.data.map(item => ({
          name: item.categoryValue,
          value: item.estimate
      }));
      
    };

    const preparePieChartProductionData = () => {
        if (!productionData || !productionData.data) {
            console.log('Production data is missing or invalid:', productionData);
            return [];
        }
        const prepared = productionData.data.map(item => ({
            name: item.categoryValue,
            value: item.estimate
        }));
        return prepared;
    };

    const preparePieChartIncomeData = () => {
        if (!incomeData || !incomeData.data) return [];
        const uniqueItems = new Map();
        incomeData.data.forEach(item => {
            const key = `${item.categoryValue}-${item.estimate}`;
            if (!uniqueItems.has(key)) {
                uniqueItems.set(key, {
                    name: item.categoryValue,
                    value: item.estimate
                });
            }
        });
        return Array.from(uniqueItems.values());
    };

    const preparePieChartExpenseData = () => {
        if (!expenseData || !expenseData.data) return [];
        return expenseData.data.map(item => ({
            name: item.categoryValue,
            value: item.estimate
        }));
    };

    

    return (
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: {xs: "start", sm: "start", md: "center"}, width: "95%", height: "90%", textAlign: "center", marginTop: { xs: "4.5rem", sm: "2rem", md: "0" } }}>
            

            
            {loading ? (
                <CustomLoader />
            ) : (

              <Grid container direction="row" spacing={1} sx={{display: "flex", justifyContent: "center"}}>
                <Grid item xs={12} >
                  <Typography variant="h4" sx={{ marginTop: "6rem", fontWeight: "bold" }}>Farms Data Analysis</Typography>
                </Grid>
                <Grid item xs={12} sx={{display: "flex", justifyContent: "center", mb: "2.5rem", }}>
                    <TextField
                        sx={{textAlign: "start", width: {xs: "90%", sm: "60%", md: "40%"}}}
                        variant="standard"
                        fullWidth={true}
                        select
                        label={<Typography variant="body2">Select Year</Typography>}
                        value={year}
                        onChange={(e)=>yearChange(e)}
                        autoComplete="off"
                    >
                        {YEARS.map((el) => (
                            <MenuItem key={el} value={el}>
                                {el}
                            </MenuItem>
                        ))}
                    </TextField> 
                </Grid>
                {foodData && foodData.data.length > 0 &&
                  <Grid item xs={12} sm={6} md={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Grid container direction="column" sx={{width: "100%"}}>
                      <Grid item sx={{display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center"}}>
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>{"Total Acres (1,000 Acres)"}</Typography>
                      </Grid>
                      <Grid item sx={{width: "100%"}}>
                        <ResponsiveContainer width="100%" height={300}>  
                            <PieChart width={200} height={200}>
                                <Pie
                                  data={preparePieChartData()}
                                  cx="50%"
                                  cy="50%"
                                  labelLine={false}
                                  label={({ cx, cy, midAngle, innerRadius, outerRadius, name, value }) => {
                                            const RADIAN = Math.PI / 180;
                                            const radius = outerRadius + 20; // Move label 20px outside the outer edge
                                            const x = cx + radius * Math.cos(-midAngle * RADIAN);
                                            const y = cy + radius * Math.sin(-midAngle * RADIAN);
                                            // const percentage = (value * 100).toFixed(2);
                                            // const percentage = Math.round(value * 100);

                                            return (
                                            <g>
                                                {/* Name Text */}
                                                <text
                                                    x={x}
                                                    y={y - 10} // Adjust y position for stacking
                                                    fill="#333"
                                                    fontSize={window.innerWidth < 600 ? 6 : 11}
                                                    fontWeight="bold"
                                                    textAnchor={x > cx ? 'start' : 'end'}
                                                    dominantBaseline="central"
                                                >
                                                    {name}
                                                </text>
                                                {/* Percentage Text */}
                                                <text
                                                    x={x}
                                                    y={y + 11} // Adjust y position to display below the name
                                                    fill="#888"
                                                    fontSize={11}
                                                    textAnchor={x > cx ? 'start' : 'end'}
                                                    dominantBaseline="central"
                                                >
                                                    {`${new Intl.NumberFormat('en-US').format(value)}`}
                                                </text>
                                            </g>
                                            );
                                        }}
                                  outerRadius={window.innerWidth < 600 ? 40 : 80}
                                  fill="#8884d8"
                                  dataKey="value"
                              >
                                  {preparePieChartData().map((entry, index) => (
                                      <Cell 
                                          key={`cell-${index}`} 
                                          fill={COLORS[index % COLORS.length]} 
                                      />
                                  ))}
                              </Pie>
                              <Tooltip />
                              {/* <Legend /> */}
                            </PieChart>
                        </ResponsiveContainer>
                      </Grid>
                    </Grid>
                  </Grid>
                }
                {productionData && productionData.data && productionData.data.length > 0 &&
                  <Grid item xs={12} sm={6} md={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Grid container direction="column" sx={{width: "100%"}}>
                      <Grid item sx={{display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center"}}>
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>{"Total Production Value (USD 1,000)"}</Typography>
                      </Grid>
                      <Grid item sx={{width: "100%"}}>
                        <ResponsiveContainer width="100%" height={300}>
                          <PieChart width={200} height={200}>
                            <Pie data={preparePieChartProductionData()} cx="50%" cy="50%" labelLine={false} label={({ cx, cy, midAngle, innerRadius, outerRadius, name, value }) => {
                              const RADIAN = Math.PI / 180;
                              const radius = outerRadius + 20;
                              const x = cx + radius * Math.cos(-midAngle * RADIAN);
                              const y = cy + radius * Math.sin(-midAngle * RADIAN);
                              return (
                                <g>
                                  {/* Name Text */}
                                  <text
                                    x={x}
                                    y={y - 10}
                                    fill="#333"
                                    fontSize={window.innerWidth < 600 ? 6 : 11}
                                    fontWeight="bold"
                                    textAnchor={x > cx ? 'start' : 'end'}
                                    dominantBaseline="central"
                                  >
                                    {name}
                                  </text>
                                  {/* Percentage Text */}
                                  <text
                                    x={x}
                                    y={y + 11}
                                    fill="#888"
                                    fontSize={11}
                                    textAnchor={x > cx ? 'start' : 'end'}
                                    dominantBaseline="central"
                                  >
                                    {`$ ${new Intl.NumberFormat('en-US').format(value)}`}
                                  </text>
                                </g>
                              );
                            }} outerRadius={window.innerWidth < 600 ? 40 : 80} fill="#8884d8" dataKey="value">
                              {preparePieChartProductionData().map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                              ))}
                            </Pie>
                            <Tooltip />
                          </PieChart>
                        </ResponsiveContainer>
                      </Grid>
                    </Grid>
                  </Grid>
                }
                
                {incomeData && incomeData.data.length > 0 && 
                  <Grid item xs={12} sm={6} md={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Grid container direction="column" sx={{width: "100%"}}>
                      <Grid item sx={{display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center"}}>
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>Total Income Per Farm</Typography>
                      </Grid>
                      <Grid item sx={{width: "100%"}}>
                        <ResponsiveContainer width="100%" height={300}>
                          <PieChart width={200} height={200}>
                        <Pie data={preparePieChartIncomeData()} cx="50%" cy="50%" labelLine={false} label={({ cx, cy, midAngle, innerRadius, outerRadius, name, value }) => {
                          const RADIAN = Math.PI / 180;
                          const radius = outerRadius + 20;
                          const x = cx + radius * Math.cos(-midAngle * RADIAN);
                          const y = cy + radius * Math.sin(-midAngle * RADIAN); 
                          return (
                            <g>
                              {/* Name Text */}
                              <text
                                x={x}
                                y={y - 10}
                                fill="#333"
                                fontSize={window.innerWidth < 600 ? 6 : 11}
                                fontWeight="bold"
                                textAnchor={x > cx ? 'start' : 'end'}
                                dominantBaseline="central"
                              >
                                {name}
                              </text>
                              {/* Percentage Text */}
                              <text
                                x={x}
                                y={y + 11}
                                fill="#888"
                                fontSize={11}
                                textAnchor={x > cx ? 'start' : 'end'}
                                dominantBaseline="central"
                              >
                                {`$ ${new Intl.NumberFormat('en-US').format(value)}`}
                              </text>
                            </g>
                          );
                        }} outerRadius={window.innerWidth < 600 ? 40 : 80} fill="#8884d8" dataKey="value">
                          {preparePieChartIncomeData().map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                        <Tooltip />
                        </PieChart>
                        </ResponsiveContainer>
                      </Grid>
                    </Grid>
                  </Grid>
                }
                {expenseData && expenseData.data.length > 0 && 
                  <Grid item xs={12} sm={6} md={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Grid container direction="column" sx={{width: "100%"}}>
                      <Grid item sx={{display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center"}}>
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>Operating Expenses Ratio</Typography>
                      </Grid>
                      <Grid item sx={{width: "100%"}}>
                          <ResponsiveContainer width="100%" height={300}>
                          <PieChart width={200} height={200}>
                        <Pie data={preparePieChartExpenseData()} cx="50%" cy="50%" labelLine={false} label={({ cx, cy, midAngle, innerRadius, outerRadius, name, value }) => {
                          const RADIAN = Math.PI / 180;
                          const radius = outerRadius + 20;
                          const x = cx + radius * Math.cos(-midAngle * RADIAN);
                          const y = cy + radius * Math.sin(-midAngle * RADIAN);
                          return (
                            <g>
                              {/* Name Text */}
                              <text
                                x={x}
                                y={y - 10}
                                fill="#333"
                                fontSize={window.innerWidth < 600 ? 6 : 11}
                                fontWeight="bold"
                                textAnchor={x > cx ? 'start' : 'end'}
                                dominantBaseline="central"
                              >
                                {name}
                              </text>
                              {/* Percentage Text */}
                              <text
                                x={x}
                                y={y + 11}
                                fill="#888"
                                fontSize={11}
                                textAnchor={x > cx ? 'start' : 'end'}
                                dominantBaseline="central"
                              >
                                {`${new Intl.NumberFormat('en-US').format(value)}%`}
                              </text>
                            </g>
                          );
                        }} outerRadius={window.innerWidth < 600 ? 40 : 80} fill="#8884d8" dataKey="value">
                          {preparePieChartExpenseData().map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                        <Tooltip />
                        </PieChart>
                        </ResponsiveContainer>
                      </Grid>
                    </Grid>
                  </Grid>
                }
              </Grid>
            )}
        </Box>
      </Box>
    );  
}
